import axios from 'axios';
import authHeader from './auth-header';

var path =  require('@/assets/json/path.json')
const API_URL = `${path.api}`;

class UserService {

  verifyIsStaff() {
    return axios.get(API_URL + path.admin.verify, { headers: authHeader() })
  }

  verifyIsAuth() {
    return axios.get(API_URL + path.user.verify, { headers: authHeader() })
  }

  getWebBank(user) {
    return axios.get(API_URL + path.dashboard.player.bank + user + '/', { headers: authHeader() })
  }

  getCharacters(username) {
    return axios.get(API_URL + path.dashboard.player.base + username + path.dashboard.player.character, { headers: authHeader() })
  }

  getActivity(url=null, page_num=0) {
    var new_path = API_URL + path.dashboard.report.player.activity
    if (url) new_path = url
    if (page_num>0) new_path+=`?page=${page_num}`
    return axios.get(new_path, { headers: authHeader() })
  }

  getCharactersBasics(char=null) {
    var params = ''
    if (char) params+= `?name_like=${char}`
    return axios.get(API_URL + path.dashboard.player.characterBasics + params, { headers: authHeader() })
  }

  getServerCharacterZen(id) {
    return axios.get(API_URL + path.dashboard.server.zen + id + '/', { headers: authHeader() })
  }

  getCredits(id) {
    return axios.get(API_URL + path.dashboard.player.credits + id + '/', { headers: authHeader() })
  }

  getCharacterReset(id) {
    return axios.get(API_URL + path.dashboard.server.reset + id + '/', { headers: authHeader() })
  }

  updateZenBank(id, data) {
    return axios.patch(API_URL + path.dashboard.player.zen + id + '/', data, { headers: authHeader() })
  }

  updateCredits(id, data) {
    return axios.patch(API_URL + path.dashboard.player.credits + id + '/', data, { headers: authHeader() })
  }

  updateCharacterZen(id, data) {
    return axios.patch(API_URL + path.dashboard.player.zenCharacter + id + '/', data, { headers: authHeader() })
  }

  updateServerCharacterZen(id, data) {
    return axios.patch(API_URL + path.dashboard.server.zen + id + '/', data, { headers: authHeader() })
  }

  updateCharacterVip(id, data={}) {
    return axios.patch(API_URL + path.dashboard.server.vip + id + '/', data, { headers: authHeader() })
  }

  updateCharacterReset(id, data) {
    return axios.patch(API_URL + path.dashboard.server.reset + id + '/', data, { headers: authHeader() })
  }

  makeCreditTransfer(data) {
    return axios.post(API_URL + path.dashboard.player.creditsTransfer, data, { headers: authHeader() })
  }

  buyCredits(data) {
    return axios.post(API_URL + path.dashboard.player.CreditsPurchase, data, { headers: authHeader() })
  }
}

export default new UserService();